import { FC, useEffect, useState } from 'react'
import '../../styles/css/dictionary/modalwindow/main_dialog.css'
import { Button, Modal } from 'antd'
import { AttentionIcon } from '../elements/svg_icons/AttentionIcon'

interface ConfirmModalDialogProps {
    message: string,
    decline: () => void,
    confirm: () => void,
    open: boolean;

}

const ConfirmModalLoadingDialog: FC<ConfirmModalDialogProps> = ({ message, decline, confirm, open }) => {

    const [loading, setLoading] = useState<boolean>(false)


    useEffect(() => {
        if (!open) {
            setLoading(false)
            decline()
        }
    }, [open]) // Runs when myProp changes

    const confirmFn = () => {
        confirm()
        setLoading(true)
    }

    return (
        <Modal onCancel={decline}
               footer={[
                   <Button key='submit' danger onClick={decline}>
                       Отмена
                   </Button>,
                   <Button
                       loading={loading}
                       onClick={confirmFn}
                       type='primary'
                   >
                       Да
                   </Button>
               ]}
               open={open}>
            <div id='main-dialog_message'>
                <AttentionIcon />
                <span>{message}</span>
            </div>

        </Modal>
    )
}

export default ConfirmModalLoadingDialog
